<template>
	<v-row class="ma-0 pb-offset">
		<v-col cols="12" class="pa-0">
			<v-card class="flex pa-0 background-2 round-card">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3">Configurazione Pianificatore</p>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-divider></v-divider>
				<v-list three-line subheader class="background-2 a-2">
					<v-subheader>Fasce Orarie Predefinite</v-subheader>
					<v-list-item>
						<v-list-item-content>
							<v-list-item-subtitle class="mb-3">
								Configura le fasce orarie standard (es. Mattina, Pomeriggio, All-day).
								Quando un dispatcher crea un evento nel pianificatore, potrà selezionare
								una fascia con un toggle: start e end verranno applicati all'evento
								e propagati a tutti i tecnici della squadra.
							</v-list-item-subtitle>

							<time-slots-editor
								:field="{
									label: 'Fasce Orarie',
									key: 'time_slots',
									hint: 'Le fasce saranno mostrate come pulsanti toggle nel dialog di creazione evento.'
								}"
								:model="settings"
								ref="time_slots"
							></time-slots-editor>
						</v-list-item-content>
					</v-list-item>

					<v-divider class="my-2"></v-divider>

					<v-subheader>Ruoli Operatori Pianificabili</v-subheader>
					<v-list-item>
						<v-list-item-content>
							<v-list-item-subtitle class="mb-3">
								Seleziona i ruoli i cui utenti possono essere assegnati come operatori nel
								pianificatore. Se nessun ruolo è selezionato vengono mostrati tutti gli utenti
								(comportamento predefinito). Utile per escludere ruoli amministrativi e lasciare
								solo i tecnici.
							</v-list-item-subtitle>

							<v-autocomplete
								v-model="settings.user_roles"
								:items="rolesOptions"
								item-text="text"
								item-value="value"
								label="Ruoli"
								multiple
								chips
								small-chips
								deletable-chips
								outlined
								dense
								clearable
								hide-details
								:loading="loadingRoles"
								:menu-props="{'offset-y': true}"
							></v-autocomplete>
						</v-list-item-content>
					</v-list-item>
				</v-list>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text class="mx-2" color="primary" @click.native="saveSettings">Salva</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'
import TimeSlotsEditor from '@/components/common/TimeSlotsEditor.vue'

export default {
	name: 'planner-settings',
	mixins: [SettingsOptionsMixin],
	components: { TimeSlotsEditor },
	data() {
		return {
			model: 'planners',
			settings: {
				time_slots: [],
				user_roles: [],
			},
			rolesOptions: [],
			loadingRoles: false,
		}
	},
	created() {
		this.loadingRoles = true
		this.axios.post('getoptionfields/', { model: 'Role', value: 'value', relation_field: 'name', key: 'text' })
			.then(res => { this.rolesOptions = (res.data && res.data.option_fields) || [] })
			.finally(() => { this.loadingRoles = false })
	},
}
</script>

<style scoped>
</style>
